var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3438 163.905C127.388 163.905 163.904 127.389 163.904 82.3442C163.904 37.2996 127.388 0.783691 82.3438 0.783691C37.2991 0.783691 0.783203 37.2996 0.783203 82.3442C0.783203 127.389 37.2991 163.905 82.3438 163.905Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3431 150.652C120.068 150.652 150.651 120.069 150.651 82.344C150.651 44.6186 120.068 14.0361 82.3431 14.0361C44.6176 14.0361 14.0352 44.6186 14.0352 82.344C14.0352 120.069 44.6176 150.652 82.3431 150.652Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.38 82.3424C137.38 51.9466 112.739 27.3059 82.3431 27.3059C51.9473 27.3059 27.3066 51.9466 27.3066 82.3424C27.3066 112.738 51.9473 137.379 82.3431 137.379C112.739 137.379 137.38 112.738 137.38 82.3424Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.108 82.3447C124.108 59.2785 105.41 40.5796 82.3433 40.5796C59.277 40.5796 40.5781 59.2785 40.5781 82.3447C40.5781 105.411 59.277 124.11 82.3433 124.11C105.41 124.11 124.108 105.411 124.108 82.3447Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3489 110.85C98.0962 110.85 110.862 98.084 110.862 82.3367C110.862 66.5894 98.0962 53.8237 82.3489 53.8237C66.6016 53.8237 53.8359 66.5894 53.8359 82.3367C53.8359 98.084 66.6016 110.85 82.3489 110.85Z",
    stroke: "#FF6D00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesIcon);
export default __webpack_public_path__ + "static/media/circles-icon.4ea7c15785a0a58d2346d1ec838153aa.svg";
export { ForwardRef as ReactComponent };